import { useEffect } from 'react';
import { Check, AlertCircle } from 'lucide-react';
import './Toast.css';

const Toast = ({ message, type, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(onClose, 3000);
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className={`toast ${type}`}>
      {type === 'success' && <Check />}
      {type === 'error' && <AlertCircle />}
      {message}
    </div>
  );
};

export default Toast;
